import React, { useMemo, useEffect } from 'react';

import capitalize from 'lodash/capitalize';

import {
  LegacyBox,
  Divider,
  SidePage,
  List,
  ListItem,
  ListItemText,
} from '@gogame/components';
import { useProcessAsync, useMountedState } from '@gogame/hooks-ts';
import { useScreenState } from '@gogame/screens';

import { useLoadDictionary } from 'scenes/BulkUpload/hooks';

import MessageContainer from './MessageContainer';

const DictionarySidePage = ({ onClose, onExited, open }) => {
  const [data, setData] = useMountedState([]);
  const [activeMenu, setActiveMenu] = useMountedState(0);
  const [loading, processAsync] = useProcessAsync();
  const screenState = useScreenState();
  const loadDictionary = useLoadDictionary(processAsync);

  const loadData = async () => {
    let response = await loadDictionary({ partner: screenState.partner });
    setData(response.fields);
  };

  useEffect(() => {
    loadData();
  }, []);

  const activeItems = useMemo(() => {
    return data[activeMenu] ? data[activeMenu].values : [];
  }, [data, activeMenu]);

  const handleOpenGroup = (index) => {
    setActiveMenu(index);
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={loading}
      open={open}
      size={'lg'}
    >
      <SidePage.Title title={`${capitalize(screenState.partner)} Bulk Help`} />
      <SidePage.Content disableGutters={true}>
        <LegacyBox style={{ minHeight: '100%' }}>
          <List>
            {data.map(({ name }, index) => (
              <ListItem
                key={index}
                button={true}
                selected={activeMenu === index}
                onClick={() => handleOpenGroup(index)}
              >
                <ListItemText>{name}</ListItemText>
              </ListItem>
            ))}
          </List>
          <Divider orientation={'vertical'} flexItem />
          <MessageContainer items={activeItems} data={data} vertical={true} />
        </LegacyBox>
      </SidePage.Content>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};

export default DictionarySidePage;
